import * as React from 'react';
import { UIText2, UIText3 } from '@cian/ui-kit';
import { getAgentType } from '../../../utils/agent';
import { Underground } from '../../Underground';
import * as styles from './NewbuildingRecommendation.css';
export var NewbuildingRecommendation = function NewbuildingRecommendation(_ref) {
  var recommendation = _ref.recommendation;
  var agentLabel = recommendation.agentLabel,
      agentName = recommendation.agentName,
      agentType = recommendation.agentType,
      buildingStatusInfo = recommendation.buildingStatusInfo,
      newbuildingName = recommendation.newbuildingName,
      underground = recommendation.underground,
      formattedPrice = recommendation.formattedPrice,
      photoUrl = recommendation.photoUrl;
  var displayName = "\u0416\u041A \xAB".concat(newbuildingName, "\xBB");
  var displayType = getAgentType(agentType, agentLabel);
  var displayBuilder = "".concat(displayType, " ").concat(agentName).trim();
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container'],
    "data-testid": "newbuilding-recommendation"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['image'],
    style: {
      backgroundImage: "url(".concat(photoUrl, ")")
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-item']
  }, /*#__PURE__*/React.createElement(UIText3, {
    display: "block",
    color: "gray60_100"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, displayBuilder))), /*#__PURE__*/React.createElement("div", {
    className: styles['content-item']
  }, /*#__PURE__*/React.createElement(UIText2, {
    display: "block",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, displayName))), /*#__PURE__*/React.createElement("div", {
    className: styles['content-item']
  }, /*#__PURE__*/React.createElement(UIText2, {
    display: "block"
  }, formattedPrice)), /*#__PURE__*/React.createElement("div", {
    className: styles['content-item']
  }, /*#__PURE__*/React.createElement(UIText2, {
    display: "block"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['text']
  }, buildingStatusInfo)))), underground && underground.name && underground.color && /*#__PURE__*/React.createElement(Underground, {
    color: underground.color,
    name: underground.name,
    transportType: underground.transportType,
    time: underground.time
  }));
};